module.exports = __webpack_public_path__ + "06_hair_brown.95bf0e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/06_hair_brown.png
// module id = d/dl
// module chunks = 0